import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import HdmgdjHome from "../pages/hdmgdj-home/page";
import HdmgdjDownload from "../pages/hdmgdj-download/page";
import HdmgdjReport from "../pages/hdmgdj-report/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <HdmgdjHome />,
  },
  {
    path: "/hdmgdj-download",
    element: <HdmgdjDownload />,
  },
  {
    path: "/report",
    element: <HdmgdjReport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;